import { Component, Input, OnInit } from '@angular/core';
import { UpcomingRemindersService } from '../../services/upcoming-reminders/upcoming-reminders.service';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { cancelUpcomingReminder } from 'app/dashboard/features/dashboard.actions';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { SCHEDULE_TYPE } from 'app/core/enums/schedule-type.enum';

@Component({
  selector: 'app-upcoming-reminders-card',
  templateUrl: './upcoming-reminders-card.component.html',
  styleUrls: ['./upcoming-reminders-card.component.scss']
})
export class UpcomingRemindersCardComponent implements OnInit {

  @Input() reminder

  public reminders = null;

  public campaignName = null;
  public reminderTypeText = '';
  public reminderTypeColor = '';
  public scheduledTime = '';

  public month = ''
  public day = ''
  public year = ''

  constructor(
    public upcomingRemindersService: UpcomingRemindersService,
    public store: Store,
  ) { }

  ngOnInit(): void {
    this.reminderTypeColor = this.getSchedulerColor(this.reminder.type)

    this.campaignName = this.getCampaignName(this.reminder)
    this.reminderTypeText = this.getSchedulerType(this.reminder.type)

    this.getScheduledTime(this.reminder.scheduledTimeUnix)
  }

  getCampaignName(reminder) {
    let type = reminder.type;
    switch (type) {
      case SCHEDULE_TYPE.TICKET_REMINDER:
      case SCHEDULE_TYPE.TICKET_ADD_GUEST_REMINDER:
      case SCHEDULE_TYPE.TICKET_INVITE_REMINDER:
      case SCHEDULE_TYPE.SILENT_AUCTION_CLOSING:
      case SCHEDULE_TYPE.CLOSE_AUCTION:  
      case SCHEDULE_TYPE.CUSTOM_SILENT_AUCTION_REMINDER:
      case SCHEDULE_TYPE.P2P_UPDATE_TO_CHAMPIAN:
      case SCHEDULE_TYPE.SEND_PARTY_SIGNUP_REMINDER:
      case SCHEDULE_TYPE.SEND_PARTY_SIGNUP_REMINDER_TO_HOST:
      case SCHEDULE_TYPE.SCHEDULE_TASK_SEND_SHOPPING_REMINDER:
        return reminder.campaignData.name
      case SCHEDULE_TYPE.PENDING_CART_REMINDER:
        return 'Pending Cart Reminder'
      case SCHEDULE_TYPE.VIRTUAL_EVENT_REMINDER:
      case SCHEDULE_TYPE.VIRTUAL_EVENT_INVITE_REMINDER:
        return reminder.virtualEventInfo.name
      case SCHEDULE_TYPE.IN_PERSON_EVENT_REMINDER:
      case SCHEDULE_TYPE.IN_PERSON_ADD_GUEST_REMINDER:
      case SCHEDULE_TYPE.IN_PERSON_SAVE_CARD_REMINDER:
        return reminder.inPersonEventInfo.name
      case SCHEDULE_TYPE.EVENT_PAGE_INVITE_REMINDER:
        if(reminder.inPersonEventInfo) {
          return reminder.inPersonEventInfo.name
        } 
        if(reminder.virtualEventInfo) {
          return reminder.virtualEventInfo.name
        }
      default:
        return 'Unknown'
    }
  }

  getSchedulerType(type) {
    let reminderTypeText = ''

    switch (type) {
      case SCHEDULE_TYPE.TICKET_REMINDER:
        reminderTypeText = 'Ticket reminder'
        break;
      case SCHEDULE_TYPE.TICKET_ADD_GUEST_REMINDER:
        reminderTypeText ='Add Guest reminder'
        break;
      case SCHEDULE_TYPE.PENDING_CART_REMINDER:
        reminderTypeText ='Pending Cart reminder'
        break;
      case SCHEDULE_TYPE.SILENT_AUCTION_CLOSING:
        reminderTypeText ='Silent Auction Closing'
        break;
      case SCHEDULE_TYPE.CLOSE_AUCTION:
        reminderTypeText ='Close Auction'
        break;
      case SCHEDULE_TYPE.VIRTUAL_EVENT_REMINDER:
        reminderTypeText ='Virtual Event reminder'
        break;
      case SCHEDULE_TYPE.IN_PERSON_EVENT_REMINDER:
        reminderTypeText ='In-Person Event reminder'
        break;
      case SCHEDULE_TYPE.IN_PERSON_ADD_GUEST_REMINDER:
        reminderTypeText ='In-Person Add Guest reminder'
        break;
      case SCHEDULE_TYPE.TICKET_INVITE_REMINDER:
        reminderTypeText ='Invite reminder'
        break;
      case SCHEDULE_TYPE.EVENT_PAGE_INVITE_REMINDER:
        reminderTypeText ='Event Page Invite reminder'
        break;
      case SCHEDULE_TYPE.VIRTUAL_EVENT_INVITE_REMINDER:
        reminderTypeText ='Virtual Event Invite reminder'
        break;
      case SCHEDULE_TYPE.P2P_UPDATE_TO_CHAMPIAN:
        reminderTypeText ='Fundraiser Progress reminder'
        break;
      case SCHEDULE_TYPE.IN_PERSON_SAVE_CARD_REMINDER:
        reminderTypeText ='Save Card reminder'
        break;
      case SCHEDULE_TYPE.SEND_PARTY_SIGNUP_REMINDER:
        reminderTypeText ='Party reminder to All'
        break;
      case SCHEDULE_TYPE.SEND_PARTY_SIGNUP_REMINDER_TO_HOST:
        reminderTypeText ='Party reminder to Host'
        break;
      case SCHEDULE_TYPE.SCHEDULE_TASK_SEND_SHOPPING_REMINDER:
        reminderTypeText ='Merchandise reminder'
        break;
      case SCHEDULE_TYPE.CUSTOM_SILENT_AUCTION_REMINDER:
        reminderTypeText ='Custom Silent Auction reminder'
        break;
        
      default:
        break;
    }

    return reminderTypeText;
  }

  getSchedulerColor(type) {
    let color = ''

    switch (type) {
      case SCHEDULE_TYPE.TICKET_REMINDER:
        color = '#FF9500'
        break;
      case SCHEDULE_TYPE.TICKET_ADD_GUEST_REMINDER:
        color ='#D5CDFC'
        break;
      case SCHEDULE_TYPE.TICKET_INVITE_REMINDER:
        color ='#D5CDFC'
        break;
      case SCHEDULE_TYPE.PENDING_CART_REMINDER:
        color ='#E6BFBB'
        break;
      case SCHEDULE_TYPE.SILENT_AUCTION_CLOSING:
        color ='#ADF2B9'
        break;
      case SCHEDULE_TYPE.CLOSE_AUCTION:
        color ='#ADF2B9'
        break;
      case SCHEDULE_TYPE.VIRTUAL_EVENT_REMINDER:
        color ='#FF9500'
        break;
      case SCHEDULE_TYPE.VIRTUAL_EVENT_INVITE_REMINDER:
        color ='#D5CDFC'
        break;
      case SCHEDULE_TYPE.IN_PERSON_EVENT_REMINDER:
        color ='#FF9500'
        break;
      case SCHEDULE_TYPE.IN_PERSON_ADD_GUEST_REMINDER:
        color ='#D5CDFC'
        break;
      case SCHEDULE_TYPE.EVENT_PAGE_INVITE_REMINDER:
        color ='#B8E9FF'
        break;
      default:
        color ='#D5CDFC'
        break;
    }

    return color;
  }

  getScheduledTime(unix) {
    const currentDate = new Date();
    const datetime = moment(unix * 1000);

    const month = datetime.format("MMM");
    const day = datetime.format("D");
    const year = datetime.format("YYYY");

    const time = datetime.format("h:mma");
    const timeZone = moment.tz(currentDate, moment.tz.guess()).zoneAbbr();

    this.month = month;
    this.day = day;
    this.year = year;

    this.scheduledTime = `${time} ${timeZone}`
  }

  cancelReminder() {
    if(this.reminder.type === 5) {
      const action = DialogActions.openDialog({
        payload: {
          name: "actionSuccess",
          options: {
            size: 'small',
            modalClass:'modal--paybee modal-sm',
            containerClass:'mdb-modal-backdrop-paybee'
          },
          initialState: {
            header: "Notification",
            text: `You can cancel this automated auction close date and time by turning the "Enable Automatic Auction Close" field OFF in the Auction Settings for your campaign.`,
            callback: () => {
              
            }
          }
        }
      });
      return this.store.dispatch(action);
    }

    const taskId = this.reminder.id
    const title = "Are you sure?";
    const campaignName = this.getCampaignName(this.reminder);

    let message = ''
    if(this.reminder.type === 3) {
      message = `Cancel <b>${campaignName}</b>.`;
    } else {
      message = `Cancel <b>${campaignName}</b> Reminder.`;
    }
    
    return window['orgMain'].confirmDialogSimpleMd(title, message).then((asd)=> {
      this.store.dispatch({
        type: cancelUpcomingReminder.type,
        payload: taskId 
      });
    })
    .catch((error) => { })
  }

  ngOnDestroy() { }
}
